import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import LoadingScreen from "@/components/LoadingScreen";
import ErrorBoundary from "@/components/ErrorBoundary";
import VoiceIdeias from "@/components/VoiceIdeias";
import LandingPage from "@/pages/LandingPage";
import BlockedPage from "@/pages/BlockedPage";
import PaymentPage from "@/pages/PaymentPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPaymentsPage from "@/pages/admin/AdminPaymentsPage";
import AdminConfigPage from "@/pages/admin/AdminConfigPage";
import AdminPromotionsPage from "@/pages/admin/AdminPromotionsPage";
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import SharedIdeaPage from "@/pages/SharedIdeaPage";
import MessagesPage from "@/pages/MessagesPage";

function AppToaster() {
  const { isDark } = useTheme();
  return (
    <Toaster
      position="top-center"
      richColors
      theme={isDark ? "dark" : "light"}
      toastOptions={{
        style: isDark
          ? { background: '#0A0A0A', border: '1px solid rgba(255,255,255,0.1)' }
          : { background: '#ffffff', border: '1px solid rgba(0,0,0,0.08)' },
      }}
    />
  );
}

/* AppRoutes: LoadingScreen is rendered as an OVERLAY on top of Routes.
   Routes are ALWAYS mounted. This avoids React swapping subtrees
   (which triggers removeChild and can fail if browser extensions
   have modified the DOM). */
function AppRoutes() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<VoiceIdeias />} />
        <Route path="/login" element={<LandingPage />} />
        <Route path="/cadastro" element={<LandingPage />} />
        <Route path="/bloqueado" element={<BlockedPage />} />
        <Route path="/pagamento" element={<PaymentPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/pagamentos" element={<AdminPaymentsPage />} />
        <Route path="/admin/configuracoes" element={<AdminConfigPage />} />
        <Route path="/admin/propagandas" element={<AdminPromotionsPage />} />
        <Route path="/admin/usuarios" element={<AdminUsersPage />} />
        <Route path="/compartilhado/:token" element={<SharedIdeaPage />} />
        <Route path="/mensagens" element={<MessagesPage />} />
      </Routes>
      {loading && <LoadingScreen />}
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <AdminAuthProvider>
            <BrowserRouter>
              <div className="App">
                <AppRoutes />
              </div>
              <AppToaster />
            </BrowserRouter>
          </AdminAuthProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
